import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router';
import { withSnackbar } from 'notistack';
import { Button, Grid, TextField, CircularProgress, Tooltip, Drawer } from '@material-ui/core';
import { LabelValueCard, RevisionHistory, PageLoader, DeletePopUp, CustomChip, CustomDropzone, PreviewDocsModal } from '../../../../shared_elements';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { assetId } from '../../../../constants';
import { capitalizeFirstLetter, checkApiStatus, checkPermission, downloadFile, toastFlashMessage } from '../../../../utils_v2';
import { fieldValidation, dateRangeValidation } from '../../../../utils_v2/formValidation';
import { addRelatedLoanApi, getRelatedLoanApi } from '../apiServices';
import { addRelatedLoan, errorCode } from '..';
import { globalDeleteService, globalPostService } from '../../../../utils_v2/globalApiServices';
import { addAttachmentApi, deleteAttachmentApi } from '../../../../shared_elements/apiServices';
import { Autocomplete } from '@material-ui/lab';

class RealatedLoanCRU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      formSubmitLoader: false,
      pageLoader: false,
      mode: '',
      relatedLoan: {},
      error: {},
      previewDocs: '',
      deleteAttachmentModal: false,
      deleteItem: null,
      attachedDoc: []
    }
    this.addRelatedLoanApi = addRelatedLoanApi.bind(this);
    this.getRelatedLoanApi = getRelatedLoanApi.bind(this);
  }
  onFieldChange = (event, keyParam, data) => {
    this.setState(prevState => ({
      ...prevState,
      relatedLoan: {
        ...prevState.relatedLoan,
        [keyParam]: data
      }
    }))
  }
  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]: message
      }
    }))
  }
  toggleFnc = (key, status) => {
    this.setState({ [key]: status })
  }
  addAttachment = (data) => {
    const { props, params } = this.props;
    const { attachedDoc, relatedLoan } = this.state;
    let formdata = new FormData();

    attachedDoc.forEach(item => {
      formdata.append('files', item);
    });

    formdata.append('asset_type', assetId[params?.type])
    formdata.append('asset_slug', params.aircraft_slug);
    formdata.append('contract_slug', params.contract_slug);
    formdata.append('model_type', '11');
    formdata.append('object_id', data?.data?.id)
    this.setState({ pageLoader: true });
    globalPostService(`contracts/attachments/`, formdata)
      .then(response => {
        if (response.data.statusCode === 200) {
          this.props.getResponseBack();
          toastFlashMessage(data?.message, 'success');
        } else {
          toastFlashMessage(response.data.message, 'error');
        }
        this.setState({ pageLoader: false });
      });
  }
  addEditRelatedLoanFn = () => {
    const { relatedLoan } = this.state;
        let validationInputs = {
          name:errorCode['name'][fieldValidation({...errorCode['relatedLoanObj'], fieldval: relatedLoan?.name })],
        };
    if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === ''})){
      if (this.state.attachedDoc?.length + relatedLoan?.attachments?.length > 50) {
        this.props.enqueueSnackbar('Only 50 attachment can be attached.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return;
      }
      this.setState({ formSubmitLoader: true });
      this.addRelatedLoanApi(this.props, relatedLoan)
        .then(response => {
          this.setState({ formSubmitLoader: false });
          if (checkApiStatus(response)) {
            if (this.state.attachedDoc?.length) {
              addAttachmentApi(response?.data, this.props, this.state.attachedDoc, "23", this.toggleFnc);
              this.setState({ modal: false, mode: '', relatedLoan: {}, error: {} });
            } else {
              this.props.getResponseBack();
              this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
              this.setState({ modal: false, mode: '', relatedLoan: {}, error: {} });
            }

          } else {
            this.props.enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
          }
        })
      }else{
        this.setState({error: validationInputs});
      }
    }
  previewDoc(item) {
    this.setState({ previewDocs: item })
  }
  handleDelete = (item) => {
    this.setState({ deleteAttachmentModal: true, deleteItem: item });
  };

  deleteAttachment = (item) => {
    const { relatedLoan, deleteItem } = this.state;
    this.setState({ deleteAttachmentModal: false, pageLoader: true });
    globalDeleteService(`contracts/attachments/${deleteItem.uuid}/`)
      .then((response) => {
        this.setState({ pageLoader: false });
        if (response?.data?.statusCode === 200) {
          const updatedAttachment = relatedLoan.attachments.filter((file) => file.uuid !== deleteItem.uuid);
          this.setState({ relatedLoan: { ...relatedLoan, attachments: updatedAttachment } });
          this.getRelatedLoanApi(this.props, relatedLoan.id)
          toastFlashMessage(response?.data?.message, 'success');
        } else {
          toastFlashMessage(response?.data?.message, 'error');
        }
      })
  };


  getDeleteResponse = () => {
    const { relatedLoan, deleteItem } = this.state
    const updatedAttachments = relatedLoan?.attachments?.filter(
      attachment => attachment.uuid !== deleteItem?.uuid
    );
    this.setState(prevState => ({
      ...prevState,
      relatedLoan: {
        ...prevState.relatedLoan,
        attachments: updatedAttachments
      }
    }))
    this.props.getResponseBack()
  }
  render() {
    const { modal, formSubmitLoader, mode, relatedLoan, error, pageLoader, previewDocs, deleteAttachmentModal } = this.state;
    const { id, m, contractInfo } = this.props;
    return (
      <Fragment>
        {pageLoader ? <PageLoader /> : null}
        {id ?
          <span onClick={() => this.getRelatedLoanApi(this.props, id, m)}><Tooltip title="View"><VisibilityIcon color='primary' fontSize='small' style={{ cursor: 'pointer' }} /></Tooltip></span> :
          (contractInfo?.hdlineInfo?.archived_asset == false ?
            <Button onClick={() => this.setState({ modal: true, relatedLoan: addRelatedLoan, mode: 'add' })} variant="contained" color="primary"><AddIcon fontSize='small' />Add Related Loan</Button>
            : null)
        }
        {modal ?
          <Drawer
            open={modal}
            anchor="right"
            onClose={() => this.setState({ modal: false, mode: '', relatedLoan: {}, error: {} })}
          >
            <div style={{ width: '670px' }} className="drawer-container">
              <div className="drawer-header" alignItems='center'>
                <span className="left-blk">{`${capitalizeFirstLetter(mode)} Related Loan`}</span>
                <CloseIcon className="close-icon" onClick={() => this.setState({ modal: false })} />
                {mode !== 'add' ?
                  <ul className="list-inline right-blk">
                    <li className="list-inline-item">
                      <RevisionHistory
                        url='audit/contracts/ctrelatedloan/'
                        queryParams={{ action: 1, object_id: id }}
                        buttonType={false}
                      />
                    </li>
                    <li className="list-inline-item">
                      {contractInfo?.hdlineInfo?.archived_asset == false ? checkPermission('contracts','related_loan', 'U') && mode === 'view' && <span className="cta" onClick={() => this.setState({ mode: 'edit' })}><EditIcon className="edit-icon" />Edit</span> : false}
                      {mode !== 'view' && <span className="cta" onClick={() => this.setState({ mode: 'view' })}><VisibilityIcon className="view-icon" />View</span>}
                    </li>
                  </ul> : null
                }
              </div>
              <div className="drawer-body" style={{ position: "sticky" }}>
                <Grid container spacing={3}>
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Component" value={relatedLoan?.name ? relatedLoan.name : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          required
                          id="name"
                          label="Name"
                          fullWidth
                          margin="normal"
                          value={relatedLoan?.name || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'name', e.target.value)}
                          error={error.name ? true:false }
                          helperText={error.name ? error.name: ''}
                          onFocus={(e) => this.updateErrorField('name', '')}
                        />
                      </Grid>
                    }
                  {mode === 'view' ?
                    <LabelValueCard xs={12} label='Loan Status' value={relatedLoan?.loan_status ? relatedLoan?.loan_status : '--'} /> :
                    <Grid item xs={12}>
                      {(() => {
                        let options = ['Yes', 'No'];
                        return (
                          <Autocomplete
                            options={options}
                            disableClearable={true}
                            getOptionLabel={option => option}
                            name="loan_status"
                            value={relatedLoan?.loan_status}
                            onChange={(e, value) => { this.onFieldChange(e, 'loan_status', value); }}
                            renderInput={params => <TextField {...params} label="Loan Status" placeholder='Select YES/NO' margin="normal" fullWidth InputLabelProps={{ shrink: true }} />}
                          />
                        )
                      })()}
                    </Grid>
                  }
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Description" value={relatedLoan?.description ? <span dangerouslySetInnerHTML={{ __html: relatedLoan?.description.replace(/\n/g, '<br />') }} /> : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="description"
                          label="Description"
                          fullWidth
                          multiline
                          rows={4}
                          margin="normal"
                          value={relatedLoan?.description || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'description', e.target.value)}
                        />
                      </Grid>
                    }
                  {mode === 'view' ?
                    <div style={{ marginLeft: '8px', marginBottom: '20px' }}>
                      <p style={{ fontSize: '14px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular" }}>Attachment(s) {relatedLoan?.attachments?.length > 0 ? `[Count : ${relatedLoan?.attachments?.length}]` : null}</p>
                      {relatedLoan?.attachments?.length ? relatedLoan?.attachments && relatedLoan?.attachments.map((file, index) => (
                        <CustomChip
                          style={{ marginRight: '4px', marginTop: '7px' }}
                          title={file.name}
                          index={index}
                          label={file.name.substring(0, 14) + '...'}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file }) }}
                        />
                      )) : '--'}
                    </div>
                    :
                    (
                      <Grid item xs={12} style={{ marginBottom: '20px' }} className='drag-drop'>
                        <p style={{ fontSize: '13px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular", marginLeft: '8px' }}>Attachment(s)</p>
                        <CustomDropzone
                          onChange={(files) => this.setState({ attachedDoc: files })}
                          componentData={relatedLoan}
                          attachedDoc={this.state.attachedDoc}
                        >
                        </CustomDropzone>
                        {relatedLoan?.attachments && relatedLoan?.attachments.map((file, index) => (
                          <CustomChip
                            style={{ marginRight: '4px', marginTop: '7px' }}
                            title={file.name}
                            index={index}
                            label={file.name.substring(0, 14) + '...'}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file }) }}
                            onDelete={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ deleteAttachmentModal: true, deleteItem: file }); }}
                          />
                        ))}
                      </Grid>)}
                </Grid>
              </div>
              <div className="drawer-footer">
                {mode !== 'view' ?
                  <Button onClick={this.addEditRelatedLoanFn} color="primary" variant="contained" disabled={formSubmitLoader}>
                    {formSubmitLoader ? <CircularProgress color="#ffffff" size={24} /> : 'Save Changes'}
                  </Button> : null
                }
                <Button onClick={() => this.setState({ modal: false, mode: '', relatedLoan: {}, error: {} })} color="primary" style={mode == 'view' ? { marginLeft: 'auto', paddingLeft: '0px' } : { marginLeft: '8px' }}>Cancel</Button>
              </div>
            </div>
          </Drawer> : null
        }
        {
          this.state.previewDocs ? <PreviewDocsModal previewDocs={this.state.previewDocs} toggleModalFn={() => this.setState({ previewDocs: '' })} /> : null
        }
        {this.state.deleteAttachmentModal ?
          <DeletePopUp
            modal={this.state.deleteAttachmentModal}
            toggleModalFn={() => this.setState({ deleteAttachmentModal: false })}
            title="Delete Attachment"
            content={<h4>Are you sure you want to delete?</h4>}
            deleteRecordFn={() => deleteAttachmentApi(this.state.deleteItem, this.toggleFnc, this.getDeleteResponse)}
          /> : null
        }
      </Fragment>
    )
  }
}
export default withRouter(withSnackbar(RealatedLoanCRU));
